import request from "@/lib/request";

const headers = {
  AppKey: "BpLnfgDs"
};

export const getSmsRecordList = params =>
  request.request({
    url: "/v1/admin/cmn/sms/list",
    method: "get",
    params,
    headers
  });

export const getEmailRecordList = params =>
  request.request({
    url: "/v1/admin/cmn/email/list",
    method: "get",
    params,
    headers
  });
